import { Dispatch } from 'react';
import { copyToClipboard } from '~/src/helpers/copy-to-clipboard.helper';
import {
    setReferralAgentLinkAction,
    setStateReferralAgentLinkAction,
} from '~/src/redux/referral-agent/referral-agent.slice';
import { ReferralAgentLinkEnum } from '~/src/models/enums/referral-agent-link.enum';

export const generateRefLink = (link: string, dispatch: Dispatch<unknown>) => {
    if (link.length) {
        copyToClipboard(link);
        dispatch(setReferralAgentLinkAction(link));
        dispatch(setStateReferralAgentLinkAction(ReferralAgentLinkEnum.success));
    } else {
        dispatch(setStateReferralAgentLinkAction(ReferralAgentLinkEnum.error));
    }
};
